import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

/*
    - ihoDesignSystem
*/
import { Alert, Box, Button, Container, Drawer, Dropdown, Grid, Image, Modal, List, Link, TextField, Typography } from '@iho-design-system/Loader';

/*
    - component
*/
import Tab from '../components/header/Tab';

/*
    - icon
*/
import LogoSVG from '../assets/images/icons/logo.svg';
import LogoSmallSVG from '../assets/images/icons/logo-small.svg';
import UserType1SVG from '../assets/images/icons/user-type-1.svg';
import BadgeSVG from '../assets/images/dashboard/badge.svg';
import WalletSVG from '../assets/images/icons/wallet.svg';
import ExitSVG from '../assets/images/icons/exit.svg';
import MenuSVG from '../assets/images/icons/menu.svg';
import CloseDrawerSVG from '../assets/images/icons/close-drawer.svg';
import ArrowLeftBlueSVG from '../assets/images/icons/arrow-left-blue.svg';
import LockDarkSVG from '../assets/images/icons/lock-dark.svg';
import MessageDarkSVG from '../assets/images/icons/message-dark.svg';
import OrgDarkSVG from '../assets/images/icons/org-dark.svg';
import ObserverSVG from '../assets/images/icons/observer.svg';
import LoadingCustomSVG from '../assets/images/icons/loading-custom.svg';
import AlertDangerSVG from '../assets/images/icons/alert-danger.svg';

/*
    - api
*/
import dashboardBadgesAPI from '../api/get/DashboardBadges';
import userPlanDetailsAPI from '../api/get/UserPlanDetails';
import userProfileAPI from '../api/get/UserProfile';
import walletBalanceAPI from '../api/get/WalletBalance';
import RequestOrganizationCodeAPI from '../api/add/RequestOrganizationCode';
import RequestOrganizationCodeWithAuthAPI from '../api/add/RequestOrganizationCodeWithAuth';
import ChangePasswordAPI from '../api/edit/ChangePassword';

const Header = ({ props }) => {

    /*
        - defaultData
    */
    const location = useLocation();
    const type = localStorage.getItem('type');
    const [headerData, setHeaderData] = React.useState({
        dashboardBadges: 'empty',
        userPlanDetails: 'empty',
        userProfile: 'laoding',
        walletBalance: 0
    });
    const [requestedCode, setRequestedCode] = React.useState({
        value: '',
        color: 'dark'
    });
    const [foreignOrganizationName, setForeignOrganizationName] = React.useState('');
    const [foreignCode, setForeignCode] = React.useState('');
    const [organizationCodeAlert, setOrganizationCodeAlert] = React.useState('');
    const [changePasswordParameters, setChangePasswordParameters] = React.useState({
        currentPassword: {
            value: '',
            color: 'dark'
        },
        newPassword: {
            value: '',
            color: 'dark'
        },
        confirmNewPassword: {
            value: '',
            color: 'dark',
            hint: ''
        }
    });

    /*
        - alert
    */
    const [alert, setAlert] = React.useState('');
    const [alertColor, setAlertColor] = React.useState('success');
    const [alertStatus, setAlertStatus] = React.useState('d-none');
    const alertProps = (config) => {
        setAlert(config[1])
        setAlertColor(config[0]);
        setAlertStatus('d-flex');
        setTimeout(() => {
            setAlertStatus('d-none');
        }, 2500);
    }

    /*
        - fetchData
    */
    React.useEffect(() => {
        const fetchData = async () => {
            setHeaderData({
                dashboardBadges: await dashboardBadgesAPI(),
                userPlanDetails: await userPlanDetailsAPI(),
                userProfile: await userProfileAPI(),
                walletBalance: await walletBalanceAPI()
            });
        }
        fetchData();
    }, [props]);

    /*
        - requestedCodeHandler
    */
    const requestedCodeHandler = (value) => {
        if (value !== '') {
            setRequestedCode({
                value: value,
                color: 'dark'
            });
        } else {
            setRequestedCode({
                value: '',
                color: 'danger'
            });
        }
    }

    /*
        - requestOrganizationCode
    */
    const requestOrganizationCode = async () => {
        let parameters = {};
        let isValid = 1;
        if (requestedCode.value === '') {
            setRequestedCode({
                ...requestedCode,
                color: 'danger'
            });
            isValid = 0;
        }
        if (isValid === 1) {
            parameters.RequestedCode = requestedCode.value;
            let result;
            if (foreignCode === '') {
                result = await RequestOrganizationCodeAPI(parameters);
            } else {
                parameters.ForeignCode = foreignCode;
                result = await RequestOrganizationCodeWithAuthAPI(parameters);
                if (result.status === 200) {
                    console.log('here')
                    closeModal('requestOrganizationCodeModal');
                    alertProps(['success', 'با موفقیت انجام شد']);
                }
            }
            if (result.status === 200 && foreignCode === '') {
                if (result.data.stepTwoIsRequired === false) {
                    setRequestedCode({
                        value: '',
                        color: 'dark'
                    });
                    closeModal('requestOrganizationCodeModal');
                    alertProps(['success', 'با موفقیت انجام شد']);
                } else {
                    setForeignOrganizationName(result.data.foreignOrganizationName);
                }
            } else if (result.data.Code === 43) {
                setOrganizationCodeAlert('کد سازمانی اشتباه است');
            } else if (result.data.Code === 96) {
                setOrganizationCodeAlert('درخواست کد سازمانی قبلا ارسال شده است');
            } else if (result.data.Code === 157) {
                // setOrganizationCodeAlert('پزشکی با این مشخصات یافت نشد');
                setOrganizationCodeAlert(result.data.Message);
            }
        }
    }

    /*
        - changePasswordHandler
    */
    const changePasswordHandler = (key, value) => {
        if (key === 'currentPassword' && value !== '' && value.length >= 6) {
            setChangePasswordParameters({
                ...changePasswordParameters,
                currentPassword: {
                    value: value,
                    color: 'dark'
                }
            });
        } else if (key === 'currentPassword') {
            setChangePasswordParameters({
                ...changePasswordParameters,
                currentPassword: {
                    value: value,
                    color: 'danger'
                }
            });
        }
        if (key === 'newPassword' && value !== '' && value.length >= 6) {
            setChangePasswordParameters({
                ...changePasswordParameters,
                newPassword: {
                    value: value,
                    color: 'dark'
                }
            });
        } else if (key === 'newPassword') {
            setChangePasswordParameters({
                ...changePasswordParameters,
                newPassword: {
                    value: value,
                    color: 'danger'
                }
            });
        }
        if (key === 'confirmNewPassword' && value !== '' && value === changePasswordParameters.newPassword.value) {
            setChangePasswordParameters({
                ...changePasswordParameters,
                confirmNewPassword: {
                    value: value,
                    color: 'dark'
                }
            });
        } else if (key === 'confirmNewPassword') {
            setChangePasswordParameters({
                ...changePasswordParameters,
                confirmNewPassword: {
                    value: value,
                    color: 'danger',
                    hint: 'رمز جدید با رمز وارد شده مطابقت ندارد'
                }
            });
        }
    }

    /*
        - changePassword
    */
    const changePassword = async () => {
        let parameters = {};
        let isValid = 1;
        if (changePasswordParameters.currentPassword.value === '') {
            setChangePasswordParameters({
                ...changePasswordParameters,
                currentPassword: {
                    color: 'danger'
                }
            });
            isValid = 0;
        }
        if (changePasswordParameters.newPassword.value === '') {
            setChangePasswordParameters({
                ...changePasswordParameters,
                newPassword: {
                    color: 'danger'
                }
            });
            isValid = 0;
        }
        if (changePasswordParameters.confirmNewPassword.value !== changePasswordParameters.newPassword.value) {
            setChangePasswordParameters({
                ...changePasswordParameters,
                confirmNewPassword: {
                    color: 'danger'
                }
            });
            isValid = 0;
        }
        if (isValid === 1) {
            parameters.CurrentPassword = changePasswordParameters.currentPassword.value;
            parameters.NewPassword = changePasswordParameters.newPassword.value;
            parameters.ConfirmNewPassword = changePasswordParameters.newPassword.value;
            let result = await ChangePasswordAPI(parameters);
            if (result === 'success') {
                closeModal('changePasswordModal');
                alertProps(['success', 'با موفقیت انجام شد']);
            } else {
                closeModal('changePasswordModal');
                alertProps(['danger', 'خطایی رخ داده است']);
            }
            setChangePasswordParameters({
                ...changePasswordParameters,
                currentPassword: {
                    value: '',
                    color: 'dark'
                },
                newPassword: {
                    value: '',
                    color: 'dark'
                },
                confirmNewPassword: {
                    value: '',
                    color: 'dark',
                    hint: ''
                }
            });
        }
    }

    /*
        - componentData
    */
    let tabData = [];
    tabData.userProfile = headerData.userProfile;
    tabData.dashboardBadges = headerData.dashboardBadges;

    /*
        - closeDropdownProfile
    */
    const closeDropdownProfile = () => {
        document.querySelector('.profileDropdown').classList.remove('d-block');
        document.querySelector('.profileDropdown').classList.add('d-none');
    }

    /*
        - modal
    */
    const openModal = (modal) => {
        document.querySelector(`.${modal}`).classList.remove('d-none');
        closeDropdownProfile();
    }

    const closeModal = (modal) => {
        document.querySelector(`.${modal}`).classList.add('d-none');
        if (modal === 'changePasswordModal') {
            setChangePasswordParameters({
                ...changePasswordParameters,
                currentPassword: {
                    value: '',
                    color: 'dark'
                },
                newPassword: {
                    value: '',
                    color: 'dark'
                },
                confirmNewPassword: {
                    value: '',
                    color: 'dark',
                    hint: ''
                }
            });
        }
        setRequestedCode({
            value: '',
            color: 'dark'
        });
        setForeignOrganizationName('');
        setForeignCode('');
        setOrganizationCodeAlert('');
    }

    /*
        - drawer
    */
    const openDrawer = () => {
        document.querySelector('.drawer').classList.remove('d-none');
    }

    const closeDrawer = () => {
        document.querySelector('.drawer').classList.add('d-none');
    }

    React.useEffect(() => {
        // svUx1
        // 8x8wW
        document.querySelector('.drawer_drawer__svUx1').addEventListener('click', (event) => {
            let drawerClass = event.target.classList;
            if (!drawerClass.contains('drawer_wrapper__svUx1')) {
                closeDrawer();
            }
            return false;
        });
    }, []);

    /*
        - scale
    */
    const screenWidth = window.innerWidth;
    let scale = '';
    if (screenWidth > 1400) {
        scale = 'xx-large';
    } else if (screenWidth <= 1400 && screenWidth > 1200) {
        scale = 'x-large';
    } else if (screenWidth <= 1200 && screenWidth > 992) {
        scale = 'large'
    } else if (screenWidth <= 992 && screenWidth > 768) {
        scale = 'medium'
    } else if (screenWidth <= 768 && screenWidth > 576) {
        scale = 'small'
    } else if (screenWidth <= 576) {
        scale = 'x-small'
    }

    let drawerSize = 'md';
    if (scale === 'x-small') {
        drawerSize = 'xl';
    }

    return (
        <React.Fragment>
            <Box
                className={`py-md bg-white shadow-dark`}
                component='div'>
                <Container
                    className={`px-sm`}
                    size={`xl`}>
                    <Grid>
                        <Grid.Wrapper
                            className={`align-item-center`}>
                            <Grid.Item
                                size='col-8'>
                                <List
                                    className={`d-flex align-item-center`}>
                                    {(scale === 'xx-large' || scale === 'x-large' || scale === 'large') &&
                                        <List.Item>
                                            <Link
                                                href='/'
                                                target='_blank'>
                                                <Image
                                                    className={`mx-lg mr-0 pointer`}
                                                    src={LogoSVG}
                                                    ms={{
                                                        width: '140px'
                                                    }} />
                                            </Link>
                                        </List.Item>
                                    }
                                    {(scale === 'medium' || scale === 'small' || scale === 'x-small') &&
                                        <List.Item
                                            onClick={openDrawer}
                                            className={`mx-lg mr-0`}>
                                            <Image
                                                src={MenuSVG}
                                                ms={{
                                                    width: '20px',
                                                    height: '20px'
                                                }} />
                                        </List.Item>
                                    }
                                    {(scale === 'medium' || scale === 'small' || scale === 'x-small') &&
                                        <List.Item>
                                            <Link
                                                href='/'>
                                                <Image
                                                    className={`mx-lg mr-0 pointer`}
                                                    src={LogoSmallSVG}
                                                    ms={{
                                                        width: '140px'
                                                    }} />
                                            </Link>
                                        </List.Item>
                                    }
                                    {(scale === 'xx-large' || scale === 'x-large' || scale === 'large') &&
                                        <React.Fragment>
                                            <List.Item
                                                className={`mx-lg pointer`}>
                                                <Link
                                                    href='/'>
                                                    رزرو هتل
                                                </Link>
                                            </List.Item>
                                            <List.Item
                                                className={`mx-lg pointer`}>
                                                <Link
                                                    href='/'>
                                                    هتل‌های ایران
                                                </Link>
                                            </List.Item>
                                            <List.Item
                                                className={`mx-lg pointer`}>
                                                <Link
                                                    href='/ecolodge/'>
                                                    اقامتگاه بوم‌گردی
                                                </Link>
                                            </List.Item>
                                            <List.Item
                                                className={`mx-lg ml-0 pointer`}>
                                                <Link
                                                    href='/Persian/pursuit/'>
                                                    پیگیری رزرو
                                                </Link>
                                            </List.Item>
                                        </React.Fragment>
                                    }
                                </List>
                            </Grid.Item>
                            <Grid.Item
                                size='col-4'>
                                <Box
                                    className={`d-flex align-item-center justify-content-end`}>
                                    {scale !== 'x-small' && scale !== 'small' && scale !== 'medium' &&
                                        <React.Fragment>
                                            <Image
                                                className={`d-inline mx-xs`}
                                                src={MessageDarkSVG}
                                                ms={{
                                                    width: '20px',
                                                    height: '20px'
                                                }} />
                                            <Link
                                                href='https://www.iranhotelonline.com/help/'>
                                                مرکز پشتیبانی
                                            </Link>
                                            <Box
                                                className={`mx-md`}
                                                ms={{
                                                    width: '1px',
                                                    height: '20px',
                                                    backgroundColor: 'var(--gray-light)'
                                                }} />
                                        </React.Fragment>
                                    }
                                    {scale === 'x-small' &&
                                        <React.Fragment>
                                            <Link
                                                href='https://www.iranhotelonline.com/help/'>
                                                <Image
                                                    className={`d-inline mx-xs`}
                                                    src={MessageDarkSVG}
                                                    ms={{
                                                        width: '20px',
                                                        height: '20px'
                                                    }} />
                                            </Link>
                                            <Box
                                                className={`mx-md`}
                                                ms={{
                                                    width: '1px',
                                                    height: '20px',
                                                    backgroundColor: 'var(--gray-light)'
                                                }} />
                                        </React.Fragment>
                                    }
                                    <Box
                                        className={`d-flex align-center py-sm px-sm border-solid border-light rounded-sm`}>
                                        <Dropdown>
                                            <Dropdown.Toggle
                                                className={`pointer`}>
                                                <Image
                                                    className={`d-inline-block`}
                                                    src={UserType1SVG}
                                                    ms={{
                                                        width: '20px',
                                                        height: '20px'
                                                    }} />
                                                <Typography
                                                    className={`mx-xs ml-0`}
                                                    component='p'
                                                    ms={{
                                                        '@media(max-width: 576px)': {
                                                            display: 'none'
                                                        }
                                                    }}>
                                                    {headerData.userProfile.status === 200 && (headerData.userProfile.data.firstName === '' || headerData.userProfile.data.lastName === '') &&
                                                        <React.Fragment>
                                                            کاربر ایران هتل
                                                        </React.Fragment>
                                                    }
                                                    {type === 'B2C' && (headerData.userProfile.status === 200 && (headerData.userProfile.data.firstName !== '' || headerData.userProfile.data.lastName !== '')) &&
                                                        <React.Fragment>
                                                            {headerData.userProfile.data.firstName} {headerData.userProfile.data.lastName}
                                                        </React.Fragment>
                                                    }
                                                    {type === 'B2B' && headerData.userProfile.status === 200 && headerData.userProfile.data.nickName !== '' &&
                                                        <React.Fragment>
                                                            {headerData.userProfile.data.nickName}
                                                        </React.Fragment>
                                                    }
                                                    {headerData.userProfile === 'laoding' &&
                                                        <Image
                                                            className={`d-inline`}
                                                            src={LoadingCustomSVG}
                                                            ms={{
                                                                width: '20px',
                                                                height: '20px'
                                                            }} />
                                                    }
                                                </Typography>
                                            </Dropdown.Toggle>
                                            <Dropdown.Body
                                                className='profileDropdown'
                                                position='bottomLeft'
                                                ms={{
                                                    width: '360px !important',
                                                    top: '200% !important'
                                                }}>
                                                <Image
                                                    className={`mx-auto`}
                                                    src={BadgeSVG}
                                                    ms={{
                                                        width: '65px'
                                                    }} />
                                                <Box
                                                    className={`my-lg`} />
                                                {headerData.userProfile.status === 200 &&
                                                    <Typography
                                                        className='d-block text-center'>
                                                        {headerData.userProfile.data.email}
                                                    </Typography>
                                                }
                                                <Typography
                                                    className='d-block text-center'
                                                    component='p'
                                                    ms={{
                                                        color: '#6F6F7E',
                                                        cursor: 'auto !important'
                                                    }}>
                                                    شما در سطح
                                                    {headerData.userPlanDetails.status === 200 && headerData.userPlanDetails.data !== 'empty' && headerData.userPlanDetails.data.map((obj, index) => {
                                                        return (
                                                            <React.Fragment
                                                                key={index}>
                                                                {obj.IsCurrent === true &&
                                                                    <Typography
                                                                        className={`text-dark`}
                                                                        component='span'
                                                                    >
                                                                        &nbsp;
                                                                        {obj.Title}
                                                                        &nbsp;
                                                                    </Typography>
                                                                }
                                                            </React.Fragment>
                                                        )
                                                    })}
                                                    باشگاه مشتریان قرار دارید
                                                </Typography>
                                                {type === 'B2C' && headerData.userProfile.status === 200 &&
                                                    <Typography
                                                        className='d-block text-center'
                                                        component='small'
                                                        ms={{
                                                            cursor: 'auto !important'
                                                        }}>
                                                        شما زیر مجموعه {headerData.userProfile.data.parentName} هستید.
                                                    </Typography>
                                                }
                                                <Box
                                                    className={`my-xl divider-horizontal divider-light`} />
                                                <List>
                                                    <List.Item
                                                        className={`d-flex justify-content-between`}
                                                        ms={{
                                                            cursor: 'auto !important'
                                                        }}>
                                                        <Box>
                                                            <Image
                                                                className={`d-inline-block mx-sm mr-0`}
                                                                src={WalletSVG}
                                                                ms={{
                                                                    width: '20px',
                                                                    height: '20px'
                                                                }} />
                                                            <Typography>
                                                                موجودی حساب من
                                                            </Typography>
                                                        </Box>
                                                        <Typography
                                                            className={`text-primary`}>
                                                            {headerData.walletBalance.status === 200 && headerData.walletBalance.data === 'empty' &&
                                                                <React.Fragment>
                                                                    0
                                                                </React.Fragment>
                                                            }
                                                            {headerData.walletBalance.status === 200 && headerData.walletBalance.data !== 'empty' && (Math.floor(headerData.walletBalance.data.Balance) / 10).toLocaleString()} تومان
                                                        </Typography>
                                                    </List.Item>
                                                    <Box
                                                        className={`my-md`} />
                                                    {type == 'B2B' &&
                                                        <List.Item
                                                            ms={{
                                                                '&:hover': {
                                                                    fontWeight: 'bold'
                                                                }
                                                            }}>
                                                            <Image
                                                                className={`d-inline-block mx-sm mr-0`}
                                                                src={UserType1SVG}
                                                                ms={{
                                                                    width: '20px',
                                                                    height: '20px'
                                                                }} />
                                                            <RouterLink
                                                                onClick={closeDropdownProfile}
                                                                to='/profile/base-info'>
                                                                <Typography>
                                                                    پروفایل کاربری
                                                                </Typography>
                                                            </RouterLink>
                                                        </List.Item>}
                                                    <Box
                                                        className={`my-md`} />
                                                    <List.Item
                                                        ms={{
                                                            '&:hover': {
                                                                fontWeight: 'bold'
                                                            }
                                                        }}>
                                                        <Image
                                                            className={`d-inline-block mx-sm mr-0`}
                                                            src={LockDarkSVG}
                                                            ms={{
                                                                width: '20px',
                                                                height: '20px'
                                                            }} />
                                                        {type === 'B2C' &&
                                                            <Typography
                                                                onClick={() => openModal('changePasswordModal')}
                                                                className={`pointer`}>
                                                                تغییر رمز عبور
                                                            </Typography>
                                                        }
                                                        {type === 'B2B' &&
                                                            <RouterLink
                                                                onClick={closeDropdownProfile}
                                                                to='/profile/change-pass'>
                                                                <Typography>
                                                                    تغییر رمز عبور
                                                                </Typography>
                                                            </RouterLink>
                                                        }
                                                    </List.Item>
                                                    <Box
                                                        className={`my-md`} />
                                                    <List.Item
                                                        ms={{
                                                            '&:hover': {
                                                                fontWeight: 'bold'
                                                            }
                                                        }}>
                                                        <Image
                                                            className={`d-inline mx-sm mr-0`}
                                                            src={MessageDarkSVG}
                                                            ms={{
                                                                width: '20px',
                                                                height: '20px'
                                                            }} />
                                                        <Typography>
                                                            <Link
                                                                href='https://www.iranhotelonline.com/help/'>
                                                                مرکز پشتیبانی
                                                            </Link>
                                                        </Typography>
                                                    </List.Item>
                                                    {type === 'B2C' &&
                                                        <Box
                                                            className={`my-md`} />
                                                    }
                                                    {type === 'B2C' &&
                                                        <List.Item
                                                            onClick={() => openModal('requestOrganizationCodeModal')}
                                                            ms={{
                                                                '&:hover': {
                                                                    fontWeight: 'bold'
                                                                }
                                                            }}>
                                                            <Image
                                                                className={`d-inline-block mx-sm mr-0`}
                                                                src={OrgDarkSVG}
                                                                ms={{
                                                                    width: '20px',
                                                                    height: '20px'
                                                                }} />
                                                            <Typography
                                                                onClick={closeDropdownProfile}
                                                                className={`pointer`}>
                                                                کد سازمانی
                                                            </Typography>
                                                        </List.Item>
                                                    }
                                                    <Box
                                                        className={`my-md`} />
                                                    <List.Item
                                                        ms={{
                                                            '&:hover': {
                                                                fontWeight: 'bold'
                                                            }
                                                        }}>
                                                        <Link
                                                            href='/AccountMVC/Logout?returnUrl=/'>
                                                            <Image
                                                                className={`d-inline-block mx-sm mr-0`}
                                                                src={ExitSVG}
                                                                ms={{
                                                                    width: '20px',
                                                                    height: '20px'
                                                                }} />
                                                            <Typography
                                                                className={`text-danger`}>
                                                                خروج از حساب
                                                            </Typography>
                                                        </Link>
                                                    </List.Item>
                                                </List>
                                            </Dropdown.Body>
                                        </Dropdown>
                                    </Box>
                                </Box>
                            </Grid.Item>
                        </Grid.Wrapper>
                    </Grid>
                </Container>
            </Box>
            {
                (scale === 'medium' || scale === 'small' || scale === 'x-small') &&
                <Box
                    className={`my-md`} />
            }
            <Drawer
                className={`drawer`}>
                <Drawer.Wrapper
                    size={drawerSize}>
                    <List
                        className={`p-xl`}>
                        <List.Item
                            onClick={closeDrawer}
                            className={`d-flex align-item-center text-primary`}>
                            <Image
                                src={CloseDrawerSVG}
                                alt='close'
                                ms={{
                                    width: '20px',
                                    height: '20px',
                                }} />
                            <Box
                                className={`mx-lg mr-0`} />
                            صفحه اصلی
                        </List.Item>
                        <Box
                            className={`my-xl`} />
                        <List.Item
                            className={`divider-horizontal divider-primary`} />
                        <Box
                            className={`my-xl`} />
                        <List.Item
                            className={`d-flex align-item-center justify-content-between`}>
                            <Link
                                href='/'>
                                رزرو هتل
                            </Link>
                            <Image
                                className={`mx-lg mr-0`}
                                src={ArrowLeftBlueSVG}
                                alt='enter'
                                ms={{
                                    width: '20px',
                                    height: '20px'
                                }} />
                        </List.Item>
                        <Box
                            className={`my-md`} />
                        <List.Item
                            className={`d-flex align-item-center justify-content-between`}>
                            <Link
                                href='/iran-hotels/'>
                                هتل‌های ایران
                            </Link>
                            <Image
                                className={`mx-lg mr-0`}
                                src={ArrowLeftBlueSVG}
                                alt='enter'
                                ms={{
                                    width: '20px',
                                    height: '20px'
                                }} />
                        </List.Item>
                        <Box
                            className={`my-md`} />
                        <List.Item
                            className={`d-flex align-item-center justify-content-between`}>
                            <Link
                                href='/ecolodge/'>
                                اقامتگاه بومگردی
                            </Link>
                            <Image
                                className={`mx-lg mr-0`}
                                src={ArrowLeftBlueSVG}
                                alt='enter'
                                ms={{
                                    width: '20px',
                                    height: '20px'
                                }} />
                        </List.Item>
                        <Box
                            className={`my-md`} />
                        <List.Item
                            className={`d-flex align-item-center justify-content-between`}>
                            <Link
                                href='/Persian/Pursuit/'>
                                پیگیری رزرو
                            </Link>
                            <Image
                                className={`mx-lg mr-0`}
                                src={ArrowLeftBlueSVG}
                                alt='enter'
                                ms={{
                                    width: '20px',
                                    height: '20px'
                                }} />
                        </List.Item>
                        <Box
                            className={`my-md`} />
                        <List.Item
                            className={`my-lg divider-horizontal divider-medium`} />
                        <List.Item>
                            <Typography
                                component='small'>
                                ایران هتل آنلاین نسخه 1.0
                            </Typography>
                        </List.Item>
                    </List>
                </Drawer.Wrapper>
            </Drawer>
            <Container
                size='lg'>
                {!location.pathname.includes('/profile/') &&
                    <Tab
                        props={tabData} />
                }
            </Container>
            <Modal
                className={`requestOrganizationCodeModal`}>
                <Modal.Wrapper
                    size='xs'
                    ms={{
                        '@media(max-width:576px)': {
                            width: '100% !important'
                        }
                    }}>
                    <Modal.Header
                        className={`border-solid-bottom border-light`}>
                        کد سازمانی
                        <Box />
                    </Modal.Header>
                    <Box
                        className={`my-md mt-0`} />
                    <Box
                        component='form'>
                        <Grid>
                            {organizationCodeAlert !== '' &&
                                <Grid.Item
                                    size='col-12'>
                                    <Typography
                                        className={`d-flex`}
                                        ms={{
                                            gap: 'var(--sizing-xs)',
                                            fontWeight: 'bold',
                                            color: 'var(--red-medium)'
                                        }}>
                                        <Image
                                            src={AlertDangerSVG}
                                            ms={{
                                                width: '20px',
                                                height: '20px'
                                            }} />
                                        {organizationCodeAlert}
                                    </Typography>
                                </Grid.Item>
                            }
                            <Grid.Item
                                size='col-12'>
                                <TextField
                                    onChange={requestedCodeHandler}
                                    label='کد سازمانی'
                                    color={requestedCode.color}
                                    value={requestedCode.value} />
                            </Grid.Item>
                            {foreignOrganizationName !== '' &&
                                <Grid.Item
                                    size='col-12'>
                                    <TextField
                                        onChange={setForeignCode}
                                        label={foreignOrganizationName}
                                        color={requestedCode.color}
                                        value={foreignCode} />
                                </Grid.Item>
                            }
                            <Grid.Item
                                className={`d-flex`}
                                size='col-6'>
                                <Button
                                    onClick={requestOrganizationCode}
                                    color='primary'>
                                    تایید
                                </Button>
                                <Box
                                    className={`mx-sm`} />
                                <Button
                                    onClick={() => closeModal('requestOrganizationCodeModal')}
                                    variant='outlined'
                                    color='danger'>
                                    انصراف
                                </Button>
                            </Grid.Item>
                        </Grid>
                    </Box>
                </Modal.Wrapper>
            </Modal>
            <Modal
                className={`changePasswordModal`}>
                <Modal.Wrapper
                    size='xs'
                    ms={{
                        '@media(max-width:576px)': {
                            width: '100% !important'
                        }
                    }}>
                    <Modal.Header
                        className={`border-solid-bottom border-light`}>
                        تغییر رمز عبور
                        <Box />
                    </Modal.Header>
                    <Box
                        className={`my-md mt-0`} />
                    <Box
                        component='form'>
                        <Grid>
                            <Grid.Item
                                size='col-12'>
                                <TextField
                                    onChange={(value) => changePasswordHandler('currentPassword', value)}
                                    label='رمز عبور فعلی'
                                    type='password'
                                    color={changePasswordParameters.currentPassword.color}
                                    icon={ObserverSVG}
                                    value={changePasswordParameters.currentPassword.value} />
                            </Grid.Item>
                            <Grid.Item
                                size='col-12'>
                                <TextField
                                    onChange={(value) => changePasswordHandler('newPassword', value)}
                                    label='رمز عبور جدید'
                                    hint='رمز عبور باید حداقل شامل 6 کاراکتر باشد.'
                                    type='password'
                                    color={changePasswordParameters.newPassword.color}
                                    icon={ObserverSVG}
                                    value={changePasswordParameters.newPassword.value} />
                            </Grid.Item>
                            <Grid.Item
                                size='col-12'>
                                <TextField
                                    onChange={(value) => changePasswordHandler('confirmNewPassword', value)}
                                    label='تکرار رمز عبور جدید'
                                    type='password'
                                    hint={changePasswordParameters.confirmNewPassword.hint}
                                    color={changePasswordParameters.confirmNewPassword.color}
                                    icon={ObserverSVG}
                                    value={changePasswordParameters.confirmNewPassword.value} />
                            </Grid.Item>
                            <Grid.Item
                                className={`d-flex`}
                                size='col-6'>
                                <Button
                                    onClick={changePassword}
                                    color='primary'>
                                    ذخیره رمز عبور جدید
                                </Button>
                                <Box
                                    className={`mx-sm`} />
                                <Button
                                    onClick={() => closeModal('changePasswordModal')}
                                    variant='outlined'
                                    color='danger'>
                                    انصراف
                                </Button>
                            </Grid.Item>
                        </Grid>
                    </Box>
                </Modal.Wrapper>
            </Modal>
            <Alert
                className={`alert ${alertStatus}`}
                color={alertColor}
                ms={{
                    bottom: '75px !important'
                }}>
                {alert}
            </Alert>
        </React.Fragment>
    );

}

export default Header;